module.exports = __webpack_public_path__ + "img/Wp_2033.6b693871.png";